export default {
	gettime (date) {
		const year = date.getFullYear()
		const month = date.getMonth() + 1
		const day = date.getDate()
		const hour = date.getHours()
		const minute = date.getMinutes()
		const second = date.getSeconds()
		return [year, month, day].map(this.formatNumber).join('-') + ' ' + [hour, minute, second].map(this.formatNumber).join(':')
	},

	formatNumber (n) {
		n = n.toString()
		return n[1] ? n : '0' + n
	},

	// 保留两位小数
	numtwo (n) {
		n = n.toFixed(2);
		return n
	},
	getDate(date){
		if(date){
			let year = date.getFullYear()
			let month = date.getMonth() + 1
			let day = date.getDate()
			return [year, month, day].map(this.formatNumber).join('-')
		}
		return ''
	}
}